import { NavigateFunction } from 'react-router-dom';
import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { dropAccount, dropFilters, getUsersSearch } from '~/Actions/ActionApp';
import { ROUTES } from '~/constants';
import { State } from '~/Reducers';

export const navigateToProfile =
  (id: string, navigate?: NavigateFunction): ThunkAction<void, {}, {}, AnyAction> =>
  (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
    dispatch(dropFilters());
    dispatch(dropAccount());

    const state = getState();
    const { battleTypeRaw } = state.ReducerApp;

    const target = `/statistics/${id}${battleTypeRaw ? `/${battleTypeRaw}` : ''}`;

    if (navigate) {
      navigate(target);
    } else {
      window.location.assign(target);
    }
  };

export const navigateToSearchResults =
  (query: string, navigate: NavigateFunction): ThunkAction<void, {}, {}, AnyAction> =>
  (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    dispatch(getUsersSearch(query));
    navigate(`${ROUTES.ROOT}?query=${query}`);
  };

export const navigateToRoute =
  (route: string, navigate: NavigateFunction, clb: () => void): ThunkAction<void, {}, {}, AnyAction> =>
  (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
    const state = getState();
    const { spaId } = state.ReducerApp;

    const target = route === '/' ? route : `${route}/${spaId}`;

    navigate(target);
    clb();
  };
